module.exports = __webpack_public_path__ + "img/ipsyo_logo.aef8d14f.png";